import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { trackEvent } from '../../utils/analytics';
import { setPageTitle } from '../../utils/title';
import Breadcrumb from '../../components/Breadcrumb';
import {
  SecurityIcon,
  InfrastructureIcon,
  FinOpsIcon,
  ComplianceIcon,
  AISecurityIcon,
} from '../../components/icons';
import './Solutions.scss';

const Solutions = () => {
  const location = useLocation();

  useEffect(() => {
    setPageTitle('Solutions');
  }, []);

  const breadcrumbItems = [
    { path: '/', label: 'Home' },
    { path: '/solutions', label: 'Solutions' },
  ];

  const handleTabClick = tab => {
    trackEvent('solution_tab_click', 'Solutions Page', {
      tab_name: tab,
      source_page: 'solutions',
    });
  };

  const solutions = [
    {
      id: 'security',
      title: 'Cloud Infrastructure Security',
      icon: <SecurityIcon />,
      path: '/solutions/security',
    },
    {
      id: 'infrastructure',
      title: 'Cloud Infrastructure for Systems and Apps',
      icon: <InfrastructureIcon />,
      path: '/solutions/infrastructure',
    },
    {
      id: 'finops',
      title: 'FinOps – Cost Management in the Cloud',
      icon: <FinOpsIcon />,
      path: '/solutions/finops',
    },
    {
      id: 'compliance',
      title: 'IT Compliance Solutions (GRC)',
      icon: <ComplianceIcon />,
      path: '/solutions/compliance',
    },
    {
      id: 'ai-security',
      title: 'Secure AI Deployment',
      icon: <AISecurityIcon />,
      path: '/solutions/ai-security',
    },
  ];

  return (
    <div className="solutions-page">
      <Breadcrumb items={breadcrumbItems} />
      <section className="page-header">
        <div className="container">
          <h1 className="page-header__title">Solutions</h1>
          <p className="page-header__subtitle">
            Platforms, SaaS, Applications, Data Science, AI / ML Workloads
          </p>
        </div>
      </section>

      <section className="solutions-nav">
        <div className="solutions-nav__list">
          {solutions.map(solution => (
            <Link
              key={solution.id}
              to={solution.path}
              className={`solutions-nav__item ${
                location.pathname === solution.path ? 'active' : ''
              }`}
              onClick={() => handleTabClick(solution.id)}
            >
              <span className="solutions-nav__check">{solution.icon}</span>
              <span className="solutions-nav__text">{solution.title}</span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Solutions;
